const quickLinks = [
  { href: '#king', label: '年度瓜王榜' },
  { href: '#gualist', label: '全年瓜单' },
  { href: '#month', label: '月度回望' },
  { href: '#talk', label: '热聊现场' },
  { href: '#faq', label: '食用 FAQ' },
];

const tags = ['年度盘点', '年度大瓜', '全年瓜单', '年度瓜王', '吃瓜总结', '年度排名'];

const socials = [
  { icon: 'ri-weibo-line', label: '微博' },
  { icon: 'ri-wechat-line', label: '微信' },
  { icon: 'ri-youtube-line', label: '视频号' },
  { icon: 'ri-rss-line', label: '订阅' },
];

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.5fr_1fr_1.2fr]">
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 font-heading text-lg font-black text-background-50">瓜</span>
              <span className="font-heading text-xl font-black tracking-tight">吃瓜王</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              2026 年度盘点：从娱乐到社会，全年大瓜一网打尽。热闹是别人的，记录是我们的——吃瓜有度，聊聊有礼。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href="#top"
                  aria-label={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">速览</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-foreground-700 transition-colors hover:text-foreground-950">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">关键词</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {tags.map((t) => (
                <a
                  key={t}
                  href="#gualist"
                  className="whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs font-medium text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  {t}
                </a>
              ))}
            </div>
            <p className="mt-5 text-xs leading-relaxed text-foreground-500">
              本站为静态展示页，收录内容均基于公开信源整理，仅作围观与理性讨论之用途。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">© 2026 吃瓜王 · 年度盘点专题</p>
          <p className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-eye-line"></i>
            与你一起围观这一年的 128 颗瓜
          </p>
        </div>
      </div>
    </footer>
  );
}